import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useNavigate } from 'react-router-dom'
import { getUserNotiSetting, postUserNotiSetting } from '../../api/login'
import MyShoppingSideBar from '../../components/myshopping/MyShoppingSideBar'
import { useCommonContext } from '../../components/provider/CommonProvider'
import { PageTitle } from '../../components/title/PageTitle'
import MarketingCenterModal from '../../components/home/MarketingCenterModal'
import MarketingGiveUpModal from '../../components/home/MarketingGiveUpModal'

export default function PushSetting() {
  const [date, setDate] = useState<string>('')
  const [smsAgree, setSmsAgree] = useState<boolean>(false)
  const [checkedAgree, setCheckedAgree] = useState<boolean>(false)
  const [data, setData] = useState<string>('')
  const [margetingGiveupModal, setMargetingGiveupModal] = useState<boolean>(false)
  const { setIsLottie, hasAccessToken } = useCommonContext()
  const navigate = useNavigate()

  useEffect(() => {
    if (!hasAccessToken) {
      alert('로그인이 필요한 페이지입니다.')
      navigate('/')
    }
  }, [])

  useEffect(() => {
    getUserNotiSetting().then((res) => {
      setData(res.data.advertisingConsentDate)
      const kstDate = new Date(res.data.advertisingConsentDate)
      const year = kstDate.getFullYear()
      const month = String(kstDate.getMonth() + 1) // 월은 0부터 시작하므로 1을 더해줌
      const day = String(kstDate.getDate())
      const date = `${year}. ${month}. ${day}`
      setIsLottie(false)
      setDate(date)
      setSmsAgree(res.data.isMarketing)
    })
  }, [checkedAgree])

  return (
    <>
      <div className='main_wrap'>
        <div className={isMobile ? 'contents_wrap' : 'contents_wrap sidemenu_wrap'}>
          <MyShoppingSideBar />
          <div className='myshopping_wrap'>
            <PageTitle>푸시알림 설정</PageTitle>

            <div className='push_setting_wrap'>
              <div className='inp_box push_box'>
                <div className='tit'>
                  <span>이벤트/챌린지, 프로모션, 쇼핑 등 혜택 알림</span>
                  {data === null ? null : smsAgree ? (
                    <sub>({`${date}`} 수신동의)</sub>
                  ) : (
                    <sub>({`${date}`} 수신거부)</sub>
                  )}
                </div>
                <div className='push-toggle-box'>
                  <input
                    id='push-toggle'
                    type='checkbox'
                    name='agree_sms'
                    value='disagree'
                    checked={smsAgree}
                    onChange={(e) => {
                      if (smsAgree) {
                        setMargetingGiveupModal(true)
                      } else {
                        postUserNotiSetting(true).then(() => {
                          setCheckedAgree((prev: boolean) => !prev)
                        })
                      }
                    }}
                  />
                  <label htmlFor='push-toggle'></label>
                </div>
              </div>
            </div>
            {margetingGiveupModal && (
              <MarketingGiveUpModal
                setMarketingGiveUpModal={setMargetingGiveupModal}
                setCheckedAgree={setCheckedAgree}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
